import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "departure-board__list",
  "data-departure-list": ""
}

import { PropType } from 'vue'
import type { Departure, DepartureSettings, CurrentCulture } from '../../types'
import DepartureRow from './DepartureRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeparturesList',
  props: {
  settings: {
    type: Object as PropType<DepartureSettings>,
    required: true,
  },
  departures: {
    type: Object as PropType<Departure[]>,
    required: true,
  },
  currentCulture: {
    type: Object as PropType<CurrentCulture>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.departures, (departure) => {
      return (_openBlock(), _createBlock(DepartureRow, {
        departure: departure,
        "current-culture": __props.currentCulture,
        "journey-time-text": __props.settings.journeyTimeDisplayText,
        "journey-time-text-suffix": __props.settings.journeyTimeDisplayTextSuffix
      }, null, 8 /* PROPS */, ["departure", "current-culture", "journey-time-text", "journey-time-text-suffix"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}
}

})